export default __webpack_public_path__ + "static/media/header.16bb9921.png";